/**
 * Fleet and Drivers serve trucking and surface rentals tenants alike (#815,
 * api#1041). The band names the vertical the tenant runs: Trucking when it has
 * trucking, else Surface rentals. Positive checks only.
 */
export function haulingEyebrow(hasVertical: (key: string) => boolean): string {
  if (hasVertical('trucking')) return 'Trucking';
  if (hasVertical('surface_rentals')) return 'Surface rentals';
  return 'Trucking';
}

/**
 * A fleet unit is a trailer when its free-text `type` is "trailer", case-blind.
 * The same test as GET /trucking/fleet?type=trailer (api#1045, 0507); every
 * other type (truck, tractor, picker, …) is something that pulls. Rental
 * dispatch pickers split GET /surface-rentals/fleet's units by it.
 */
export const isTrailerUnit = (type: unknown): boolean => String(type ?? '').trim().toLowerCase() === 'trailer';
